import { render, staticRenderFns } from "./ReminderEditor.vue?vue&type=template&id=b11e0fc2&"
import script from "./ReminderEditor.vue?vue&type=script&lang=js&"
export * from "./ReminderEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports